module.exports = __webpack_public_path__ + "img/01.707c2dcf.jpg";